import { DateTime } from 'luxon';

import { DISPLAY_DATE_AND_TIME_FORMAT, DISPLAY_DATE_FORMAT, INPUT_DATE_FORMAT } from '.';

export const formatDate = (date: string | Date | undefined) => format(date, DISPLAY_DATE_FORMAT);
export const formatUTCDate = (date: string | Date | undefined) => formatUTC(date, DISPLAY_DATE_FORMAT);
export const formatDateWithTime = (date: string | Date | undefined) => format(date, DISPLAY_DATE_AND_TIME_FORMAT);

export const format = (date: string | Date | undefined, outFormat: string) => {
  if (date && typeof date === 'string') {
    const isoDate = DateTime.fromISO(date, { zone: 'utc' });
    if (isoDate.isValid) return isoDate.toLocal().toFormat(outFormat);

    const inputDate = DateTime.fromFormat(date, INPUT_DATE_FORMAT, { zone: 'utc' });
    if (inputDate.isValid) return inputDate.toLocal().toFormat(outFormat);
  }

  if (date && typeof date === 'object') {
    const jsDate = DateTime.fromJSDate(date, { zone: 'utc' });
    if (jsDate.isValid) return jsDate.toLocal().toFormat(outFormat);
  }

  return '';
};

export const formatUTC = (date: string | Date | undefined, outFormat: string) => {
  if (date && typeof date === 'string') {
    const isoDate = DateTime.fromISO(date, { zone: 'utc' });
    if (isoDate.isValid) return isoDate.toUTC().toFormat(outFormat);

    const inputDate = DateTime.fromFormat(date, INPUT_DATE_FORMAT, { zone: 'utc' });
    if (inputDate.isValid) return inputDate.toUTC().toFormat(outFormat);
  }

  if (date && typeof date === 'object') {
    const jsDate = DateTime.fromJSDate(date, { zone: 'utc' });
    if (jsDate.isValid) return jsDate.toUTC().toFormat(outFormat);
  }

  return '';
};
